export class SubSpec {
  _id?: string;
  name: string = '';
  value: string = '';
  position: number = 0;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/sub-spec.model.ts